import React from 'react';
import PropTypes from 'prop-types';

import ManagedInput from 'components/form/managed_input';
import OptionLayout from './option_layout';

export default function SelectOption({ defaults, option, onRemove, onUpdate }) {
  return (
    <OptionLayout
      isOverridden={defaults.hasOwnProperty(option.name)}
      label={option.label}
      onRemove={() => onRemove([option.name])}
      onReset={() => onUpdate({ [option.name]: option.options[0].name })}
    >
      <ManagedInput
        inline={false}
        inputClassName="form-check-input"
        name={option.name}
        options={option.options.map(opt => ({ label: opt.name, value: opt.name }))}
        type="radioGroup"
        value={defaults[option.name]}
        onValueChange={value => onUpdate({ [option.name]: value })}
      />
    </OptionLayout>
  );
}

SelectOption.propTypes = {
  defaults: PropTypes.object.isRequired,
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};
